export const GIG_CART_VERIFICATION_PROMPT_CONFIG_KEY = 'gig-cart-verification-prompt-examples';

export const MAX_GIG_CART_PROMPT_EXAMPLES = 3;
export const MAX_GIG_CART_PROMPT_EXAMPLE_CHARACTERS = 10_000;
export const MAX_GIG_CART_ENTRIES = 100;

export enum GigCartVerificationIssueReason {
  UnexpectedCartItem = 'UNEXPECTED_CART_ITEM',
  OptionMismatch = 'OPTION_MISMATCH',
  QuantityMismatch = 'QUANTITY_MISMATCH',
  InvalidCartEntry = 'INVALID_CART_ENTRY',
  NeedsReview = 'NEEDS_REVIEW',
}

export interface GigCartVerificationPromptOrderLine {
  itemId: string;
  sku: string | null;
  requiredUnits: number;
  displayName: string;
  originalName: string | null;
  productSize: string | null;
}

export interface GigCartVerificationPromptInput {
  orderLines: GigCartVerificationPromptOrderLine[];
  cartHtml: string;
}

export interface GigCartVerificationPromptCartLine {
  productName: string;
  option: string;
  unitsPerListing: number;
  cartQuantity: number;
  lineTotalKrw: number;
  itemId?: string;
  issues: GigCartVerificationIssueReason[];
}

export interface GigCartVerificationPromptExpected {
  cartLines: GigCartVerificationPromptCartLine[];
  missingItemIds: string[];
}

export interface GigCartVerificationPromptExample {
  input: GigCartVerificationPromptInput;
  expected: GigCartVerificationPromptExpected;
}

export interface GigCartVerificationPromptConfig extends Record<string, unknown> {
  examples: GigCartVerificationPromptExample[];
}

export const DEFAULT_GIG_CART_VERIFICATION_PROMPT_CONFIG: GigCartVerificationPromptConfig = {
  examples: [
    {
      input: {
        orderLines: [
          {
            itemId: 'example-item-remover',
            sku: 'example-sku-remover',
            requiredUnits: 1,
            displayName: 'Example Remover',
            originalName: 'Example Remover',
            productSize: '100ml',
          },
          {
            itemId: 'example-item-lash-serum',
            sku: 'example-sku-lash-serum',
            requiredUnits: 3,
            displayName: 'Example Lash Serum 3-Pack',
            originalName: 'Example Lash Serum',
            productSize: '10ml',
          },
          {
            itemId: 'example-item-double-bundle',
            sku: 'example-sku-double-bundle',
            requiredUnits: 2,
            displayName: 'Example Double Bundle',
            originalName: 'Example Double Bundle',
            productSize: '50ml',
          },
          {
            itemId: 'example-item-mask-single',
            sku: 'example-sku-mask',
            requiredUnits: 3,
            displayName: 'Example Mask 1-Pack',
            originalName: 'Example Mask',
            productSize: '25ml',
          },
          {
            itemId: 'example-item-mask-triple',
            sku: 'example-sku-mask',
            requiredUnits: 30,
            displayName: 'Example Mask 3-Pack',
            originalName: 'Example Mask',
            productSize: '25ml',
          },
        ],
        cartHtml:
          '<div data-selected="true" data-vid="90000000002"><a href="https://example.invalid/item?vendorItemId=90000000002"><span>Example Lash Serum</span><span>10ml, 3개 묶음</span></a><del>62,400원</del><strong>15,000원</strong><input value="1"></div><div data-selected="true" data-vid="90000000001"><a href="https://example.invalid/item?vendorItemId=90000000001"><span>Example Remover</span><span>100ml, 1개</span></a><strong>5,450원</strong><input value="1"></div><div data-selected="true" data-vid="90000000003"><a href="https://example.invalid/item?vendorItemId=90000000003"><span>Example Double Bundle</span><span>50ml, 2개 묶음</span></a><strong>71,800원</strong><input value="1"></div><div data-selected="true" data-vid="90000000005"><a href="https://example.invalid/item?vendorItemId=90000000005"><span>Example Mask</span><span>25ml, 3개입</span></a><strong>139,900원</strong><small>(묶음당 13,990원)</small><input value="10"></div><div data-selected="true" data-vid="90000000004"><a href="https://example.invalid/item?vendorItemId=90000000004"><span>Example Mask</span><span>25ml, 1개입</span></a><strong>16,110원</strong><small>(1개당 5,370원)</small><input value="3"></div><aside data-component-id="selected-products-total"><span>최종 결제금액</span><strong>248,260원</strong></aside>',
      },
      expected: {
        cartLines: [
          {
            productName: 'Example Lash Serum',
            option: '10ml, 3개 묶음',
            unitsPerListing: 3,
            cartQuantity: 1,
            lineTotalKrw: 15_000,
            itemId: 'example-item-lash-serum',
            issues: [],
          },
          {
            productName: 'Example Remover',
            option: '100ml, 1개',
            unitsPerListing: 1,
            cartQuantity: 1,
            lineTotalKrw: 5_450,
            itemId: 'example-item-remover',
            issues: [],
          },
          {
            productName: 'Example Double Bundle',
            option: '50ml, 2개 묶음',
            unitsPerListing: 2,
            cartQuantity: 1,
            lineTotalKrw: 71_800,
            itemId: 'example-item-double-bundle',
            issues: [],
          },
          {
            productName: 'Example Mask',
            option: '25ml, 3개입',
            unitsPerListing: 3,
            cartQuantity: 10,
            lineTotalKrw: 139_900,
            itemId: 'example-item-mask-triple',
            issues: [],
          },
          {
            productName: 'Example Mask',
            option: '25ml, 1개입',
            unitsPerListing: 1,
            cartQuantity: 3,
            lineTotalKrw: 16_110,
            itemId: 'example-item-mask-single',
            issues: [],
          },
        ],
        missingItemIds: [],
      },
    },
  ],
};
